import { render, staticRenderFns } from "./InputAndLabel.vue?vue&type=template&id=04a119b8&scoped=true&"
import script from "./InputAndLabel.vue?vue&type=script&lang=js&"
export * from "./InputAndLabel.vue?vue&type=script&lang=js&"
import style0 from "./InputAndLabel.vue?vue&type=style&index=0&id=04a119b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a119b8",
  null
  
)

export default component.exports